import { generateApiPath } from "@routes/generatePath.ts";
import type { IExtractApiParams } from "@routes/types.ts";

const pathBase = `/allergies/`;
const pathById = `${pathBase}:allergyId/`;

type IPathByIdParams = IExtractApiParams<typeof pathById>;

export const allergies = {
  getAll: () => generateApiPath(pathBase),
  post: () => generateApiPath(pathBase),
  put: (params: IPathByIdParams) => generateApiPath(pathById, params),
  delete: (params: IPathByIdParams) => generateApiPath(pathById, params),
};
